import { DefaultTheme } from '@chakra-ui/core';
import styled, { CreateStyled } from '@emotion/styled';

export default styled as CreateStyled<DefaultTheme>;
